import React, { useContext, useEffect, useState } from "react";
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge,
  CSpinner,
  CCardBody,
  CFormSelect,
} from "@coreui/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { insert, update, remove, getProductDetails } from "src/services/Products";
import CIcon from "@coreui/icons-react";
import { cilArrowLeft, cilTrash } from "@coreui/icons";
import { Toaster } from "src/components/Toaster";
import ls from "local-storage";
import Select, { components } from "react-select";
import { getAll } from "src/services/Categories";
import { AuthContext } from "src/App";
import { AUTH_KEY } from "src/utils/auth/Authentication";
function ProductActions() {
  const Auth = useContext(AuthContext);
  const {id} = useParams();
  const [categoryOptions, setCategoryOptions] = useState([]);

  const [formData, setFormData] = useState({
    id: 0,
    sku: "",
    name: "",
    categoryID: 0,
  })

  const [loading, setLoading] = useState({
    page: !!id,
    submit: false,
    delete: false,
  });
  const [validated, setValidated] = useState(false);
  const [toaster, setToaster] = useState({
    open: false,
    message: "",
    color: "success",
  });

  const navigate = useNavigate();
  const isEdit = !!id;

  useEffect(() => {
    if (!isEdit) return;

    const fetchProductData = async () => {
      try {
        const response = await getProductDetails(id);
        const product = response.product;

        setFormData({
          id: product.id || 0,
          sku: product.sku || "",
          name: product.name || "",
          categoryID: product.category_id || 0,
        });
      } catch (error) {
        setToaster({
          open: true,
          message: "Failed to load product details",
          color: "danger",
        })
      } finally {
        setLoading((prev) => ({ ...prev, page: false }));
      }
    };

    fetchProductData();
  }, [id, isEdit]);

  useEffect(() => {
    fetchCategories();
  }, []);
  const fetchCategories = async () => {
    let response = await getAll();

    if (response.success === 1) {
      let data =
        response?.categories.map((item) => {
          return {
            id: item.id,
            label: `${item.name}`,
            value: item.id,
          };
        }) ?? [];

      setCategoryOptions(data);
    }
  };

  const handleChange = (e) => {
    const {name, value} = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading((prev) => ({ ...prev, submit: true }));

    try {
      // Prepare data for API
      const data = {
        ...formData,
        id: isEdit ? id : undefined,
      };
      
      const response = isEdit ? await update(data) : await insert(data);

      if (response?.data?.success) {
        setToaster({
          open: true,
          message: response.data.message || (isEdit ? "Product updated successfully" : "Product added successfully"),
          color: "success",
        });

        // Navigate back after successful creation
        setTimeout(() => navigate(-1), 1500);
      } else {
        throw new Error(response?.data?.message || "Operation failed");
      }
    } catch (error) {
      setToaster({
        open: true,
        message: error.message || "An error occurred",
        color: "danger",
      });
    } finally {
      setLoading((prev) => ({ ...prev, submit: false }));
    }
  }

  const handleDelete = async () => {
    // Confirm before deleting
    if (!window.confirm("Are you sure you want to delete this product? This action cannot be undone.")) {
      return;
    }

    setLoading((prev) => ({ ...prev, delete: true }));

    try {
      const response = await remove(id);

      if (response?.data?.success) {
        setToaster({
          open: true,
          message: response.data.message || "Product deleted successfully",
          color: "success",
        });

        // Navigate back after successful deletion
        setTimeout(() => navigate("/products"), 1500);
      } else {
        throw new Error(response?.data?.message || "Failed to delete product");
      }
    } catch (error) {
      setToaster({
        open: true,
        message: error.message || "An error occurred while deleting the product",
        color: "danger",
      });
    } finally {
      setLoading((prev) => ({ ...prev, delete: false }));
    }
  }

  if (loading.page) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
        <CSpinner color="primary" />
      </div>
    );
  }

  // async function fDelete() {
  //   await remove(id).then((response) => {
  //     if ((response?.data?.success ?? 0) == 1) {
  //       setMessage(response?.data?.message);
  //       setOpen(true);
  //       const data = () =>
  //         setTimeout(() => {
  //           navigate(-1);
  //         }, 2000);

  //       data();

  //       return clearTimeout(data);
  //     } else {
  //       setMessage(response?.data?.message);
  //       setOpen(true);
  //       setColor("red");
  //     }
  //   });
  // }
  // async function handleSubmit(e) {
  //   const form = e.currentTarget;
  //   e.preventDefault();
  //   e.stopPropagation();

  //   if (form.checkValidity() === false) {
  //   } else {
  //     let data = {
  //       id: id,
  //       sku: sku,
  //       name: name,
  //       categoryID: selectedCategory.value,
  //     };
  //     if (location.state) {
  //       await update(data).then((response) => {
  //         if ((response?.data?.success ?? 0) == 1) {
  //           setMessage(response?.data?.message);
  //           setOpen(true);
  //           const data = () =>
  //             setTimeout(() => {
  //               navigate(-1);
  //             }, 2000);

  //           data();

  //           return clearTimeout(data);
  //         } else {
  //           setMessage(response?.data?.message);
  //           setOpen(true);
  //           setColor("red");
  //         }
  //       });
  //     } else {
  //       await insert(data).then((response) => {
  //         if ((response?.data?.success ?? 0) == 1) {
  //           setMessage(response?.data?.message);
  //           setOpen(true);
  //           const data = () =>
  //             setTimeout(() => {
  //               navigate(-1);
  //             }, 2000);

  //           data();

  //           return clearTimeout(data);
  //         } else {
  //           setMessage(response?.data?.message ?? ls.get("errorMessage"));
  //           setOpen(true);
  //           setColor("red");
  //         }
  //       });
  //     }
  //   }
  //   setValidated(true);

  //   // e.preventDefault()
  //   // console.log('bener')
  // }
  return (
      <CCard>
      <Toaster
        open={toaster.open}
        message={toaster.message}
        setOpen={(val) => setToaster((prev) => ({ ...prev, open: val }))}
        color={toaster.color}
      />
      <CCardHeader>
        <CRow className="align-items-center">
          <CCol md={6}>
            <h5>{isEdit ? "Edit Product" : "Add Product"}</h5>
          </CCol>
          <CCol md={6} className="text-end">
            <CButton
              color="light"
              onClick={() => navigate(-1)}
              disabled={loading.submit || loading.delete}
            >
              <CIcon icon={cilArrowLeft} className="me-2" />
              Back
            </CButton>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CForm
          onSubmit={handleSubmit}
          noValidate
          validated={validated}
        >
          <div style={{ margin: "16px" }}>
            <CRow className="mb-3">
              <CCol md={3}>
                <CFormLabel>Category</CFormLabel>&nbsp;
                <CBadge color="warning">Wajib</CBadge>
              </CCol>
              <CCol>
                <CFormSelect
                  name="categoryID"
                  placeholder="Pilih Cabang"
                  value={categoryOptions.find((c) => c.value === parseInt(formData.categoryID))?.value || 1}
                  options={categoryOptions}
                  onChange={handleChange}
                  isDisabled={false}
                  feedbackInvalid="Required value"
                  required={true}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol md={3}>
                <CFormLabel>SKU</CFormLabel>&nbsp;
              </CCol>
              <CCol>
                <CFormInput
                  type="text"
                  name="sku"
                  value={formData.sku}
                  onChange={handleChange}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol md={3}>
                <CFormLabel>Nama</CFormLabel>&nbsp;
                <CBadge color="warning">Wajib</CBadge>
              </CCol>
              <CCol>
                <CFormInput
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  feedbackInvalid="Required value"
                  required
                />
              </CCol>
            </CRow>
          </div>
          <CCardFooter style={{ textAlign: "right" }}>
          {isEdit && (
                <CButton
                  color="danger"
                  className="me-2"
                  onClick={handleDelete}
                  disabled={loading.submit || loading.delete}
                >
                  {loading.delete ? (
                    <CSpinner size="sm" />
                  ) : (
                    <>
                      <CIcon icon={cilTrash} className="me-2" />
                      Delete Product
                    </>
                  )}
                </CButton>
              )}
            &emsp;
            <CButton
              style={{
                color: "black",
                backgroundColor: "white",
              }}
              onClick={() => {
                navigate(-1);
              }}
              disabled={loading.submit || loading.delete}
            >
              Cancel
            </CButton>
            &emsp;
            <CButton
              color="success"
              type="submit"
              disabled={loading.submit || loading.delete}
              style={{
                color: "white",
              }}
            >
              {loading.submit ? <CSpinner size="sm" /> : isEdit ? "Update Product" : "Create Product"}
            </CButton>
          </CCardFooter>
        </CForm>
      </CCardBody>
    </CCard>
  );
}

export default ProductActions;
